import { render, staticRenderFns } from "./AddressBook.vue?vue&type=template&id=a2fa34f6&scoped=true"
import script from "./AddressBook.vue?vue&type=script&lang=js"
export * from "./AddressBook.vue?vue&type=script&lang=js"
import style0 from "./AddressBook.vue?vue&type=style&index=0&id=a2fa34f6&prod&lang=scss&scoped=true"
import style1 from "./AddressBook.vue?vue&type=style&index=1&id=a2fa34f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2fa34f6",
  null
  
)

export default component.exports